import "./App.css";
import Homepage from "./Homepage";
import WhatsAppFloatingButton from './WhatsAppFloatingButton'; 

function App() {
  return (
    <div className="App">
      <Homepage />
      <WhatsAppFloatingButton />
    </div>
  );
}

export default App;
